// src/pages/PaymentConfirmationPage.jsx

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import UrlConfig from '../../data/UrlConfig'; // <-- IMPORTADO

// Importar componentes de UI
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function PaymentConfirmationPage() {
    const query = useQuery();
    const navigate = useNavigate();
    const { refreshUser } = useAuth();

    const [status, setStatus] = useState('loading');
    const [message, setMessage] = useState('Verificando tu pago, por favor espera...');

    useEffect(() => {
        const productId = query.get('product_id');
        const paymentId = query.get('payment_id');
        const paymentStatus = query.get('status');

        if (!productId || !paymentId || paymentStatus !== 'approved') {
            setStatus('error');
            setMessage('Los datos de pago son inválidos o el pago fue rechazado. Si crees que es un error, contacta a soporte.');
            return;
        }

        const confirmPayment = async () => {
            try {
                // <-- MODIFICADO: Se usa UrlConfig
                const response = await fetch(UrlConfig.payment_confirm, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    credentials: 'include',
                    body: JSON.stringify({ productId, paymentId })
                });

                const result = await response.json();

                if (!result.success) {
                    throw new Error(result.message);
                }
                
                setStatus('success');
                setMessage('¡Pago exitoso! Tu acceso ha sido activado.');

                // Refrescamos el estado del usuario en la app
                if (response.data && response.data.user) {
                    refreshUser(response.data.user);
                } else {
                    // Si el backend no devuelve el usuario, lo refrescamos de forma genérica
                    refreshUser();
                }

                // Redirigimos al usuario al curso que compró
                setTimeout(() => {
                    if (productId === 'manifiesta-curso-completo') {
                        navigate('/cursos/manifiesta');
                    } else {
                        // Redirección por defecto si el producto no coincide
                        navigate('/menu'); 
                    }
                }, 3000);

            } catch (error) {
                setStatus('error');
                setMessage(error.message || 'Ocurrió un error al verificar tu pago. Por favor, contacta a soporte.');
            }
        };

        confirmPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // El array vacío asegura que este efecto se ejecute solo una vez

    return (
        <Container maxWidth="sm" sx={{ mt: 8, mb: 4, textAlign: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
                {status === 'loading' && (
                    <>
                        <CircularProgress size={60} />
                        <Typography variant="h5">{message}</Typography>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main' }} />
                        <Typography variant="h4" color="success.main">{message}</Typography>
                        <Typography variant="body1">Serás redirigido en unos segundos...</Typography>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <ErrorOutlineIcon sx={{ fontSize: 80, color: 'error.main' }} />
                        <Typography variant="h5" color="error.main">Error en la Confirmación</Typography>
                        <Typography variant="body1">{message}</Typography>
                    </>
                )}
            </Box>
        </Container>
    );
}

export default PaymentConfirmationPage;